import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { ERRORS } from '../../../../constants'
import { useAppSelector } from '../../../../state/hooks'
import { selectLineItemDiscountError } from '../../../../state/slices/uiStateSlice'
import { InputErrorMessage } from './InputErrorMessage'

interface Props {
  lineItemID: string
}

export const LineItemDiscountError: FunctionComponent<Props> = ({
  lineItemID,
}) => {
  const lineItemDiscountError = useAppSelector(
    selectLineItemDiscountError(lineItemID)
  )

  let errorElement: React.JSX.Element | null = null

  if (lineItemDiscountError === ERRORS.INVALID_DISCOUNT) {
    errorElement = <T _str="Discount exceeds maximum allowed" />
  }

  if (
    lineItemDiscountError === ERRORS.INVALID_CHARACTERS ||
    lineItemDiscountError === ERRORS.NEGATIVE_DISCOUNT
  ) {
    errorElement = (
      <T
        _str="Enter a positive number"
        _context="Error message when the input is negative or contains non-numeric characters"
      />
    )
  }

  return errorElement ? <InputErrorMessage errorElement={errorElement} /> : null
}
